import { render, staticRenderFns } from "./InspectionDetailHeader.vue?vue&type=template&id=6c5cc8e9&scoped=true&"
import script from "./InspectionDetailHeader.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailHeader.vue?vue&type=style&index=0&id=6c5cc8e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cc8e9",
  null
  
)

export default component.exports